export default {
  event: {
    name: null,
    start_date: null,
    stop_collecting_registrations_at_date: null,
    stop_collecting_registrations_at_hour: null,
    stop_collecting_registrations_at_minutes: null,
    interaction_type: null,
    preview_url: null,
    last_update_at: null,
    last_update_done_by: null,
    is_visible: true,
    total_records: 0,
    questions: [],
    media: [],
    automations: {
      on_registration_email: null,
      when_form_ends: null,
      scheduled: [],
    },
  },

  lists: {
    colors: window.__RMP_EVENTS_CODE_GENERATION_DEFAULT_COLOURS__ ? window.__RMP_EVENTS_CODE_GENERATION_DEFAULT_COLOURS__.company_settings : window.__RMP_EVENTS_CODE_GENERATION_DEFAULT_COLOURS__,
    customFields: window.__RMP_EVENTS_CUSTOM_FIELDS__,
    events: window.__RMP_EVENTS__,
    questions: window.__RMP_EVENTS_LIST_OF_QUESTIONS__,
    automations: window.__RMP_EVENTS_INSTILLER_WORKFLOWS__,
    themeFonts: window.__RMP_EVENTS_FONTS_AVAILABLE_FOR_THEMES__,
    integrations: [],
    dataInteractionTypes: [],
  },

};
